import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const areaManagementRoutes: RouteRecordRaw = {
  path: "/areaManagement",
  component: Layout,
  redirect: "/areaManagement/areaList",
  name: "AreaManagement",
  meta: {
    title: "区域管理",
    icon: "homepage",
    permissionKey: "areaManagement",
  },
  children: [
    {
      path: "areaList",
      name: "AreaList",
      component: () =>
        import("@/views/Workbench/area-management/area-list/index.vue"),
      meta: {
        title: "区域列表",
        icon: "homepage",
        permissionKey: "areaManagement:areaList",
      },
    },
  ],
};

export default areaManagementRoutes;
